// test768
(768 && 0);
